import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StripeResultElement = styled.div`
  display: none;
`;

export const StripeCardElement = styled.div`
  padding: 0 20px;
  border-radius: 2px;
  display: flex;
  align-self: center;
  flex-direction: column;
  min-height: 50px;
  justify-content: center;
  width: calc(100% - 40px);
  background-color: ${props => props.theme['text-field-background']};
  @supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */ 
    width: -webkit-calc(100% - 40px);
  }
`;